import {ABusiness} from "@/views/editor/service/business";
import {h} from "vue";
import {TransactionOutlined} from "@ant-design/icons-vue";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {RadioGroupChildOption} from "ant-design-vue/es/radio/Group";

export abstract class AProfitSharing extends ABusiness {
    readonly icon = () => h(TransactionOutlined, {style: 'color: #ef4444'});
    readonly title = '分销';
    readonly description = '通过分润机制绑定推广者利益，打造一个“人人都是推广员”的共赢生态，实现业务的持续增长。';

    protected constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }

    implementations(status: EActivityStatus): RadioGroupChildOption[] {
        return {active: [{value: 'profit_sharing', label: '分润'}], preheating: [{value: 'profit_sharing', label: '分润'}], finished: []}[status]
    }
}